/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invite_Sent_NoteInputs */



/**
* | output |
* | --- |
* | "An invite email was sent. This link expires in 24 hours." |
*
* @param {Partner_Admin_Invite_Sent_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invite_sent_note = /** @type {((inputs?: Partner_Admin_Invite_Sent_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invite_Sent_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Einladungs-E-Mail wurde gesendet. Dieser Link läuft in 24 Stunden ab.")
	return /** @type {LocalizedString} */ ("An invite email was sent. This link expires in 24 hours.")
});